var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"model-list"},_vm._l((_vm.field.content),function(f){return _c(("tms-type-" + (f.type)),{key:f.key,tag:"component",attrs:{"field":f,"source":"custom","config":_vm.config}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }